<template>
  <div class="page-content">
    <div class="card">
      <p class="card-header-subtext">{{ content.description }}</p>
      <StepItem
        v-for="(item, index) in items"
        :key="`${index}-${item.id}`"
        :item="item"
      />
      <CustomIcon :name="content.image" className="card-logo" />
      <CustomButton variation="primary" :onClick="action"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
import CustomIcon from "@/components/CustomIcon.vue";
import StepItem from "@/components/StepItem.vue";

export default {
  components: {
    CustomButton,
    CustomIcon,
    StepItem,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    items: {
      type: Array,
      default: () => [
        {
          id: String,
          label: String,
          to: String,
          icon: String,
          text: String,
          description: String,
          isActive: Boolean,
          target_field: String,
          value: [String, Boolean, Array],
        },
      ],
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
